import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { AuthState } from './store/auth.reducer';
import { Observable } from 'rxjs';
import { AuthData } from './auth-data.model';
import * as AuthActions from './store/auth.actions';
import { AppConfigService } from 'app/shared/service/app-config.service';


export const Max32bitValue = 2147483647;

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    private tokenExpirationTimer: any;

    constructor(
        private _httpClient: HttpClient,
        private _store: Store<AuthState>,
        private _configService: AppConfigService
    ) { }

    login(user: { username: string, password: string }): Observable<any> {
        return this._httpClient
            .post<AuthData>(
                this._configService.config.apiUrl + '/login',
                {
                    username: user.username,
                    password: user.password,
                },
                {
                    headers: new HttpHeaders().set("No-Authorization", 'true')
                }
            );
    }

    autoLogin() {
        let authData: AuthData = JSON.parse(localStorage.getItem('authData'));
        if (authData && authData.token) {
            authData.tokenExpirationDate = new Date(authData.tokenExpirationDate);
            if (authData.tokenExpirationDate > new Date()) {
                this.getAuth(authData.token).subscribe(data => {
                    if (data) {
                        authData.userId = data.userId;
                        authData.username = data.username;
                        authData.name = data.name;
                        authData.authorities = data.authorities;
                        authData.emailDrive = data.emailDrive;
                        authData.role = data.role;
                        this._store.dispatch(new AuthActions.DoAutoLoginSuccessAction(authData));
                    }
                },
                    error => this._store.dispatch(new AuthActions.DoAutoLoginFailAction())
                );
            } else {
                this._store.dispatch(new AuthActions.DoAutoLoginFailAction());
            }
        } else {
            this._store.dispatch(new AuthActions.DoAutoLoginFailAction());
        }
    }

    autoLogout(tokenExpirationDate: Date) {
        const expirationDuration = tokenExpirationDate.getTime() - new Date().getTime();
        this.tokenExpirationTimer = setTimeout(() => {
            this._store.dispatch(new AuthActions.DoLogoutAction());
        }, expirationDuration > Max32bitValue ? Max32bitValue : expirationDuration);
    }

    clearTokenExpirationTimer() {
        if (this.tokenExpirationTimer) {
            clearTimeout(this.tokenExpirationTimer);
            this.tokenExpirationTimer = null;
        }
    }

    getAuth(token: string): Observable<any> {
        let headers = new HttpHeaders()
            .set('Authorization', token)
            .set("No-Authorization", 'true');

        return this._httpClient.get(
            `${this._configService.config.apiUrl }/users/auth`, { headers: headers }
        );
    }
}
